"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { useAui, AuiProvider } from "@assistant-ui/store";
import { resource, tapMemo } from "@assistant-ui/tap";
const TextMessagePartClient = resource(({ text, isRunning, }) => {
    const state = tapMemo(() => ({
        type: "text",
        text,
        status: isRunning ? { type: "running" } : { type: "complete" },
    }), [text, isRunning]);
    return {
        state,
        methods: {
            getState: () => state,
            addToolResult: () => {
                throw new Error("Not supported");
            },
            resumeToolCall: () => {
                throw new Error("Not supported");
            },
        },
    };
});
export const TextMessagePartProvider = ({ text, isRunning = false, children }) => {
    const aui = useAui({
        part: TextMessagePartClient({ text, isRunning }),
    });
    return _jsx(AuiProvider, { value: aui, children: children });
};
//# sourceMappingURL=TextMessagePartProvider.js.map